import React, { Component } from "react";
import ToggleDrawer from "../containers/ToggleDrawer";
import styles from "../../../assets/css/modules/shared/label-with-tooltip.css";
import TooltipIconMfa from "../form/TooltipIconMfa";


class LabelWithTooltipMfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTipVisible: false
    };
  }

  onClick = () => {
    this.setState({
      toolTipVisible: !this.state.toolTipVisible
    });
  };

  render() {


        return (
              <React.Fragment>
                <div className={"row " + styles.labelWithTooltip}>
                  <div className={"colMfa " + styles.label} >{this.props.label}</div>
                  <div className="col-1">
                    
                    {this.props.tooltipContent ? (
                      <TooltipIconMfa
                        customStyle={styles.tooltipIconMfa}
                        onToggle={this.onClick}
                      />
                    ) : null}
                    
                  </div>
                </div>
                <ToggleDrawer isOpen={this.state.toolTipVisible}>
                  <div className={"form-info-box-Mfa " + styles.tooltipText}>
                    {this.props.tooltipContent}
                  </div>
                </ToggleDrawer>
              </React.Fragment>
            );

    
    
  }
}

export default LabelWithTooltipMfa;
